import * as React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import { Href } from "../utils/helper";

const LandingImageButtons = ({ blok }) => {
  // console.log(blok)
  const widthClass = blok.width ? `w-${blok.width}` : 'w-full'

  return (
    <div id={blok?.id} {...storyblokEditable(blok)} className="container mx-auto" 
      style={{ paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`}}>
      <div className="flex flex-col sm:flex-row justify-center gap-10 p-5">
        {blok.buttons.map((button, i) => {
          return (
            <a key={i} className={`md:${widthClass} block hover:brightness-110 transition duration-700`} href={Href(button.url)}>
              <div {...storyblokEditable(button)} className={`relative w-full`}>
                <img className={`w-full h-[300px] object-cover rounded-lg`} loading="lazy" src={`${button.bgImage?.filename}/m/0x600`} alt={button.bgImage?.alt} />
                {button.imageMask && <div className={`w-full absolute inset-0 bg-gradient-to-b from-gray-950 to-transparent opacity-70 rounded-lg`}></div> }
                
                <div className={`w-full absolute inset-0 flex flex-col text-white py-5`}>
                  {/* title */}
                  <div className="text-lg p-4">
                    {button.title}
                    <img src="/icons/right-arrow-white.svg" alt="arrow-right" className="inline-block w-6 h-6 ml-2" />
                  </div>
                  {/* divider */}
                  <div className="mx-4 border-b border-white max-w-[300px]"></div>
                  {/* content */}
                  <div className="p-4">
                    <div className="" dangerouslySetInnerHTML={{ __html: renderRichText(button.content) }} />
                  </div>

                </div>
              </div>
            </a>
          )
        })}
      </div>
    </div>)
}

export default LandingImageButtons
